import script from "./pickStoreRenew.vue?vue&type=script&setup=true&lang=js"
export * from "./pickStoreRenew.vue?vue&type=script&setup=true&lang=js"

import "./pickStoreRenew.vue?vue&type=style&index=0&id=021c87fe&lang=css"

const __exports__ = script;

export default __exports__